export const MAX_X_AXIS = 15;
